const CAT1 = [
  '#378EBD',
  '#2CA29F',
  '#479260',
  '#D07800',
  '#D3343F',
  '#A757A3'
]

const CAT2 = [
  '#202346',
  '#378EBD',
  '#6F7187',
  '#9BC6DE',
  '#95D0CF',
  '#2CA29F',
  '#479260',
  '#A3C8AF',
  '#D07800',
  '#E7BB7F',
  '#E9999F',
  '#D1AACF',
  '#D3343F',
  '#A757A3'
]

const CAT3 = [
  '#8f8f8f',
  '#2CA29F',
  '#378EBD',
  '#D07800',
  '#A757A3',
  '#D3343F',
  '#CAC4B3',
  '#E7BB7F',
]

const CAT4 = [
  '#000',
  '#222',
  '#444',
  '#666',
  '#888',
  '#aaa',
  '#ccc',
  '#eee',
]

const CAT5 = [
  '#DCD8C9',
  '#A09C8A',
  '#7B7768',
  '#D3343F',
  '#474A66',
  '#479260',
  '#A757A3',
  '#2CA29F',
  '#DB993F',
  '#378EBD',
]

const CAT6 = [
  '#F8F7F4',
  '#EFECE0',
  '#DCD8C9',
  '#E9999F',
  '#C8C8D1',
  '#A3C8AF',
  '#D1AACF',
  '#95D0CF',
  '#E7BB7F',
  '#9BC6DE',
]


export const COLORS = {
    background: '#fff',
    grid: '#D4D4D4',
    text: '#202346',
    categories: CAT5,
    categoriesLight: CAT6
}